<template>
  <div
    id="top"
    :class="componentClass"
    :style="componentStyle"
  >
    <warning-internet-explorer v-if="isInternetExplorer" />
    <owa-admin-bar />

    <slot name="tophat">
      <div class="app-tophat">
        <survey-notice v-if="isShowingSurveyNotice" />
        <subscription-notices />
        <usage-notices />
        <new-pack-notice v-if="isShowingNewPackNotice" />
      </div>
    </slot>

    <slot name="header" />

    <slot
      v-if="isShowingBandana"
      name="bandana"
    >
    </slot>

    <slot name="sweatband" />
    <slot name="content" />
    <slot name="sock" />
    <slot name="footer" />
    <slot name="overlay" />

    <cookie-consent />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SubscriptionNotices from 'app/components-wa/messages/SubscriptionNotices'
  import UsageNotices from 'app/components-wa/messages/UsageNotices'
  import NewPackNotice from 'app/components-wa/messages/NewPackNotice'
  import SurveyNotice from 'app/components-wa/messages/SurveyNotice'
  import WarningInternetExplorer from './WarningInternetExplorer'
  import CookieConsent from 'app/components-wa/messages/CookieConsent'

  export default {
    name: 'Page',

    components: {
      WarningInternetExplorer,
      SubscriptionNotices,
      CookieConsent,
      UsageNotices,
      NewPackNotice,
      SurveyNotice
    },

    props: {
      customStyle: {
        type: Object,
        default: () => {}
      },
      isShowingBandana: {
        type: Boolean,
        default: false
      },
      isShowingNewPackNotice: {
        type: Boolean,
        default: false
      },
      isShowingSurveyNotice: {
        type: Boolean,
        default: true
      },
      isShowingBuildAwesomeKickstarterNotice: {
        type: Boolean,
        default: false
      },
      isBuildAwesomeIconClickable: {
        type: Boolean,
        default: false
      },
      viewSlug: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        isInternetExplorer: false,
        linkMediums: ['ad', 'email', 'social']
      }
    },

    computed: {
      ...mapGetters('kits', ['currentKits']),

      isSignedIn() {
        return this.$route.meta.isSignedIn
      },

      componentClass() {
        return [`app-container size-sm tablet:size-md ${this.viewSlug}`]
      },

      componentStyle() {
        return {
          ...{ '--desktop-grid-max-width': 'var(--laptop-grid-max-width)' },
          ...this.customStyle
        }
      },

      isShowingKitDisabledNotice() {
        return this.currentKits.length > 0 && this.currentKits[0].status === 'deactivated' && this.currentKits[0].shutdownDate !== null
      }
    },

    created() {
      /* catching events coming from outside the site - email, socials, other marketing or ads */
      if (this.linkMediums.includes(this.$route?.query?.medium)) {
        const dest = this.$route.path // destination
        const medium = this.$route.query.medium // link medium: email, social, ad, etc.
        const src = this.$route.query.src // specific source: bluesky, fa-app, fa-news, wa-news, etc.
        const series = this.$route.query.series // overall campaign e.g. free-onboarding
        const topic = this.$route.query.topic // topic e.g. 2-add-styling
        const discount = this.$route.query.discount // discount code, e.g. TRYPRO20

        this.$posthog.capture(medium, { dest, src, series, topic, discount })
      }
    },

    mounted() {
      this.isInternetExplorer = !!document.documentMode
    }
  }
</script>
